import { Spacing4, Spacing8 } from 'autogen/design-tokens/tokens';
import { SubscriptionFrequencyInfo } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import Radio from 'components/shared/inputs/radio/RadioInput';
import { SelectedFrequencyContext } from 'components/pages/PDP/components/MidSection/hooks/context';
import { useContext } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${Spacing4};
`;

const Label = styled.label`
    display: flex;
    align-items: center;
    margin-bottom: 0;
    margin-right: auto;
`;

const RadioText = styled(Typography.Body)`
    margin-left: ${Spacing8};
`;

export default function RadioGroup(subscriptionFrequencyInfo: SubscriptionFrequencyInfo): JSX.Element {
    const { choosable } = subscriptionFrequencyInfo;
    const { selectedFrequency, setSelectedFrequency } = useContext(SelectedFrequencyContext);

    return (
        <Wrapper>
            {choosable[0].frequencies.map((frequency) => (
                <Label key={frequency.id}>
                    <Radio
                        name="subscriptionFrequencyRadioSelect"
                        value={frequency.id.toString()}
                        onChange={() => setSelectedFrequency(frequency)}
                        checked={selectedFrequency.id === frequency.id}
                    />
                    <RadioText forwardedAs="span">{frequency.nameWithRecommendationText}</RadioText>
                </Label>
            ))}
        </Wrapper>
    );
}
